import React, { useContext, useEffect, useState } from 'react';
import { Form, Row, Card, Button } from 'react-bootstrap';
import Swal from 'sweetalert2'
import './template.scss';
import { Icon } from '@iconify/react';
import sendOutlined from '@iconify-icons/ant-design/send-outlined';
import { trackPromise } from "react-promise-tracker";
import caAPI from "../../../../services/caAPI";

export default function Templates({ recebeMensagemInicial }) {
    const [mensagemInicial, setMensagemInicial] = useState();
    const [listaTemplates, setListaTemplates] = useState([]);

    useEffect(() => {
        trackPromise(
            caAPI.atendimento.whatsapp.templatesAprovados().then(res => {
                setListaTemplates(res.data);
            }).catch(err => {
                Swal.fire({
                    titleText: "Erro",
                    text: "Houve um problema ao buscar ao buscar os templates de mensagens " + err,
                    icon: 'error'
                });
                return;
            })
        )
    }, []);


    function selecionaMensagem(idTemplateSelecionado) {
        const mensagem = listaTemplates.find(template => template.id.toString() === idTemplateSelecionado).mensagem;
        setMensagemInicial(mensagem.replace(/<\/?[^>]+(>|$)/g, ""))
    }


    return <>
        <div className="templatesContainer">
        <div className="cabecalhoTemplates">
            <div className="tituloTemplares">Selecione um modelo de mensagem para iniciar o atendimento</div>
            <div className="infoTemplates">Lembrando que só será possível conversar com o cliente após obter a resposta a essa mensagem.</div>
            <p />
            <div className="selecioneTemplares">Click sobre a mensagem para selecionar:</div>
        </div>
        <div className="selecaoTemplates">
            <Form>
                <Form.Group >
                    <Form.Control
                        as="radio"
                        custom
                        onChange={(event) => selecionaMensagem(event.target.id)}
                    >
                        {listaTemplates && listaTemplates.map((template) =>
                            <div key={template.id}>
                                <Row>
                                    <Card className="templateCard">
                                        <Card.Body className="templateCorpo">
                                            <Form.Check
                                                className="template"
                                                type="radio"
                                                id={template.id}
                                                value={template.id}
                                            >
                                                <Form.Check.Input type='radio' name="selecionatemplate" isValid />
                                                <Form.Label >
                                                    <div >
                                                        {template.mensagem.replace(/<\/?[^>]+(>|$)/g, "")}
                                                    </div>
                                                </Form.Label>
                                            </Form.Check>
                                        </Card.Body>
                                    </Card>
                                </Row>
                            </div>
                        )}
                        <Button className="btnEnviaPrimeiraMensagem" onClick={() => {
                            mensagemInicial ? recebeMensagemInicial(mensagemInicial, true)
                                :
                                Swal.fire({
                                    titleText: "Atenção",
                                    text: "Selecione uma mensagem para enviar",
                                    icon: 'warning'
                                });
                        }}>
                            Enviar mensagem selecionada <Icon icon={sendOutlined} color="white" />
                        </Button>

                    </Form.Control>
                </Form.Group>
            </Form>
        </div>
    </div>
    </>;
}
